function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import itemView from '../item/itemView.js';
import { GalleryComponent } from '../galleryComponent';

var GroupView =
/*#__PURE__*/
function (_GalleryComponent) {
  _inheritsLoose(GroupView, _GalleryComponent);

  function GroupView(props) {
    var _this;

    _this = _GalleryComponent.call(this, props) || this;
    _this.displayName = 'GroupView';
    _this.dom = [];
    _this.state = {};
    return _this;
  }

  var _proto = GroupView.prototype;

  _proto.createDom = function createDom(visible) {
    var _this2 = this;

    return this.props.items.map(function (item) {
      return React.createElement(itemView, _objectSpread({}, item.renderProps(_objectSpread({}, _this2.props.galleryConfig, {
        visible: visible
      })), {}, _this2.props.itemsLoveData[item.id]));
    });
  };

  _proto.shouldRender = function shouldRender() {
    var items = this.props.items;

    if (!items || !items.length) {
      return false;
    }

    return true;
  };

  _proto.isVisible = function isVisible() {
    var _this$props = this.props,
        items = _this$props.items,
        galleryConfig = _this$props.galleryConfig;

    if (this.props.allowLoop) {
      var idx = items[items.length - 1].idx;
      var currentIdx = galleryConfig.currentIdx,
          totalItemsCount = galleryConfig.totalItemsCount;
      var distance = currentIdx - idx;
      var padding = Math.floor(totalItemsCount / 2);
      return Math.abs(distance) <= padding;
    }

    return true;
  };

  _proto.render = function render() {
    return this.shouldRender() ? React.createElement("div", {
      key: "group_" + this.props.idx + "_" + this.props.items[0].id,
      "data-hook": 'group-view'
    }, this.createDom(this.isVisible())) : null;
  };

  return GroupView;
}(GalleryComponent);

export default GroupView;